module.exports = __webpack_public_path__ + "img/menu.aee23609.svg";